import React, { useEffect, useState } from 'react';
import { ccmApi } from '../lib/api';
import { NoteExpanderPage } from './note-expander';
import { NoteExpanderV2Page } from './note-expander-v2';
import { pageForProbeError } from '../lib/note-expander-v2';

// Which Note Expander this practice runs (PR 5-UI-1, O191). The v2 routes answer 403
// { reason: 'engine_v1' | 'disabled' } until the practice's engine switch is v2, so GET /v2/copy
// (gated like every v2 route, and no work past the gate) is the probe:
//   200            → the v2 page, with the reason words it already fetched;
//   any 403        → v1's page, unchanged: the engine is v1, the feature is off, or the user's
//                    role or permission is denied (app.js mounts v1 and v2 behind the same
//                    requireRole + requirePermission('noteexpander')), and v1 shows its own
//                    "not enabled" or denied state;
//   anything else  → neither page: a notice with Retry. With v2 the default engine (owner,
//                    2026-10-25), v1's page on a practice that runs v2 would refuse every action
//                    (403 engine_v2), so a failed check shows no page rather than the wrong one
//                    (REVIEW-DV2-R1 S3).

export function NoteExpanderEntry() {
  const [probe, setProbe] = useState({ state: 'checking' }); // checking | v1 | v2 | unknown

  function check() {
    setProbe({ state: 'checking' });
    ccmApi.ne2Copy()
      .then((copy) => setProbe({ state: 'v2', copy }))
      .catch((e) => setProbe({ state: pageForProbeError(e) }));
  }

  useEffect(check, []);

  if (probe.state === 'checking') return <div className="ne-empty">Loading…</div>;
  if (probe.state === 'v2') return <NoteExpanderV2Page copy={probe.copy} />;
  if (probe.state === 'unknown') {
    return (
      <div className="ne2-notice" role="status">
        <p>Couldn't load the Note Expander. Check your connection and try again.</p>
        <div className="ne2-notice-actions">
          <button type="button" className="btn sm" onClick={check}>Retry</button>
        </div>
      </div>
    );
  }
  return <NoteExpanderPage />;
}
